
<template>

    <main class="page" id="newsletterPage">

        <section class="newsletter-subscription">

            <div class="image image1 d-none d-sm-block"></div>
            <div class="image image2"></div>

            <div class="container-fluid">

                <div class="row mb-5">

                    <div class="col text-center">

                        <h2 class="text-uppercase">Pridruži se našim e-novicam</h2>

                        <div class="divider-image divider-image-3"></div>

                        <p>Why? Because you don’t want to miss out on all this<br> awesome content, that's why.</p>
                    </div>
                </div>

                <div class="row">

                    <div class="col-12 col-sm-6 offset-sm-2 col-md-4 offset-md-4 text-center">

                        <form v-on:submit.prevent="subscribeToNewsletter()">

                            <div class="input-wrapper">
                                <i class="fas fa-user"></i>
                                <input type="text" class="form-control" v-model="name" required placeholder="Vaše ime">
                            </div>

                            <div class="input-wrapper">
                                <i class="fal fa-envelope-open"></i>
                                <input type="email" class="form-control" v-model="email" required placeholder="Vaš e-naslov">
                            </div>

                            <div class="custom-control custom-checkbox user-agreement text-left">
                                <input type="checkbox" class="custom-control-input" value="1" id="agreement" required>
                                <label class="custom-control-label" for="agreement">
                                    S klikom na gumb 'Naroči se' dovoljujete, da vas lahko obveščamo o naših dogodkih in novicah ter izrecno soglašate z obdelavo osebnih podatkov za namen pošiljanja novic.
                                </label>
                            </div>

                            <button v-if="!subscribed" type="submit" class="btn btn-danger"><i class="fal fa-envelope"></i> &nbsp; Naroči se</button>
                            <p v-else class="text-success mt-5">Zahvaljujemo se vam za prijavo.<br>Vaša prijava je bila uspešna.</p>
                        </form>
                    </div>
                </div>

            </div>

        </section>

    </main>

</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        data () {
            return {

                name: "",
                email: "",
                agreement: false,
                subscribed: false
            }
        },
        methods: {

            ...mapActions([
                'loadBanners'
            ]),

            subscribeToNewsletter: function() {

                let handle = this;
                this.subscribed = true;

                jQuery.ajax({
                    url: window.cms + "newsletter",
                    type: "post",
                    data: {
                        name: handle.name,
                        email: handle.email
                    },
                    success: function(data) {

                        console.log("Success subscribing");
                        console.log(data);
                    }
                }).fail(function(error) {

                    console.log("Error subscribing");
                    console.log(error.responseText);
                })
            },

            getBanners: function() {

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.loadBanners().then(function(banners) {

                    if(banners.length > 0 && banners[0].image !== null && typeof banners[0].image !== "undefined") {

                        mainBackgroundImage.style.backgroundImage = "url("+handle.displayImage(banners[0].image, 2200)+")";
                    }
                });
            }
        },

        mounted: function() {

            this.getBanners();
        }
    }
</script>

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pages/Newsletter.vue